<template>
  <div class="w-100 bg-white p-12">
    <div class="d-flex justify-content-between static-responsive" :class="!loading && 'disable-ske'">
      <div>
        <span><strong>Datum</strong></span>
        <TableDatePicker
          class="date-picker-shadow"

          :range="true"
          :initial_date.sync="from"
          :final_date.sync="to"
        />
<!--        <TableDatePicker
          class="date-picker-shadow"
          updateModelOnConfirmation
          placeholder="Tot"
          :value="to"
          v-on:input="updateTo"
        >
          <template v-slot:heading>
            <div class="date-head">
              <p class="m-0">Tot</p>
            </div>
          </template>
        </TableDatePicker>-->
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <span class="bold m-2 ske">{{ avg_products_per_order ? avg_products_per_order.toFixed(2) : '-----' }} producten</span>
        <p class="detail text-center">Gemiddelde ordergrootte</p>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <span class="bold m-2 ske">{{ avg_orders_count ? avg_orders_count.toFixed(2) : '-----' }} producten</span>
        <p class="detail text-center">Gemiddelde orderregel per bestelling</p>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <span class="bold m-2 ske">€{{ grand_total ? grand_total.toFixed(2) : '-----' }}</span>
        <p class="detail text-center">Omzet</p>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <span class="bold m-2 ske">€{{ product_total ? product_total.toFixed(2) : '-----' }}</span>
        <p class="detail text-center">Bruto winst</p>
      </div>
      <div class="p-2 d-flex flex-column align-items-center justify-content-center">
        <span class="bold m-2 ske">{{ avg_orders_per_day ? avg_orders_per_day.toFixed(2) : '-----' }} bestellingen</span>
        <p class="detail text-center">Gemiddelde bestellingen per dag</p>
      </div>
    </div>
  </div>
</template>

<script>

import TableDatePicker from '../../components/Inputs/TableDatePickerField.vue'

export default {
  components:{
    TableDatePicker,
  },
  props: ['averageProductsPerOrder', 'totalPriceOfProducts', 'initial_date', 'final_date', 'site'],
  created() {
    this.getDetails()
  },
  data() {
    return {
      from: this.initial_date || null,
      to: this.final_date || null,
      loading: true,

      avg_orders_count: null,
      avg_orders_per_day: null,
      avg_products_per_order: null,
      grand_total: null,
      product_total: null,
    }
  },
  methods: {
    async getDetails() {
      const initial = this.from
      const final = this.to

      let orderDate = final ? [initial, final] : (initial && [initial])
      let search = ''
      if (Array.isArray(orderDate)) {
        search = ''
        orderDate.forEach(date => search += `orderDate[]=${date}&`)
      } else search = `orderDate=${search}`
      if (this.site) search += `&site=${this.site}`

      this.loading = true
      try {
        const data = (await this.axios.get(`/api/orders-analytics?${search}`, {
          query: {
            orderDate: final ? [initial, final] : (initial && [initial]),
            site: this.site,
          },
        })).data
        this.$store.dispatch('clearCacheSearch', "orders")
        Object.keys(data).forEach(key => this[key] = parseFloat(data[key] + ''))
        this.$forceUpdate()
      } catch (err) {
        this.$catchError(err)
      }
      this.loading = false
    },
  },
  watch: {
    site() {
      this.getDetails()
    },
    from() {
      this.getDetails()
      this.$emit("update:initial_date", this.from)
    },
    to() {
      this.getDetails()
      this.$emit("update:final_date", this.to)
    },
  },
}
</script>

<style scoped>
.bg-white {
  background-color: #ffffff !important;
}
.bold{
  font-size: large;
  font-weight: 700;
}
.detail{
  color: #6D6E71;
}
.date-head{
  width: 27px;
  margin: 0px;
  margin-right: 5px;
  padding-right: 5px;
  border-right: 1px solid #6D6E71;
}
.date-picker-shadow{
  box-shadow: 1px 1px 3px 0px #00000030;
}
@media screen and (max-width: 900px) {
  .static-responsive{
    display: flex;
    flex-direction: column;
  }
}
</style>
